import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "file-drop file-drop--container" }
const _hoisted_2 = { class: "file-drop--image" }
const _hoisted_3 = ["id", "accepts", "multiple"]
const _hoisted_4 = ["for"]
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "filetypes" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        class: "file-drop--image__input",
        type: "file",
        id: `imageFileDrop_${_ctx.id}`,
        accepts: _ctx.accepts,
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args))),
        onDragover: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.dragover && _ctx.dragover(...args))),
        onDragleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.dragleave && _ctx.dragleave(...args))),
        ref: "imageInput",
        multiple: _ctx.max > 1
      }, null, 40, _hoisted_3),
      _createElementVNode("label", {
        class: "file-drop--image__label",
        for: `imageFileDrop_${_ctx.id}`
      }, [
        (_ctx.hasIcon)
          ? (_openBlock(), _createBlock(_component_q_icon, {
              key: 0,
              class: "camera-icon q-mb-sm",
              name: "photo_camera",
              size: "2rem"
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.title ? _ctx.title : 'Upload image'), 1),
        _createElementVNode("div", _hoisted_6, "(" + _toDisplayString(_ctx.accepts.join(', ')) + " )", 1)
      ], 8, _hoisted_4)
    ])
  ]))
}